import { FormEvent, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey, faEnvelope, faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import BarInput from "./barInput";

interface Response {
  failure?: string;
}

const DOCS_URL = "https://docs.voltera.io/docs/partner-hub/";

export default function Login() {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [failure, setFailure] = useState<string | null>("");
  const [checking, setChecking] = useState(false);

  async function postData(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (checking) return;

    try {
      setChecking(true);
      setFailure(null);
      const response = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
        credentials: "same-origin",
        redirect: "manual",
        cache: "no-store",
      });

      // The browser stores the HttpOnly cookie on the 302. A fetch redirect
      // cannot navigate the page, so navigate to the fixed destination here.
      if (response.type === "opaqueredirect") {
        window.location.assign(DOCS_URL);
        return;
      }

      const result: Response = await response.json();
      setFailure(result.failure || "Unable to sign in. Please try again.");
    } catch {
      setFailure("Unable to sign in. Please try again.");
    } finally {
      setChecking(false);
    }
  }

  function renderButton() {
    const disable = checking || email.length < 3 || password.length < 3;
    return (
      <button className='login-submit' type='submit' disabled={disable}>
        <FontAwesomeIcon icon={checking ? faCircleNotch : faKey} spin={checking} aria-hidden='true' />
        {checking ? "Signing In..." : "Sign In"}
      </button>
    );
  }

  return (
    <form className='login-form' onSubmit={postData} aria-busy={checking}>
      <BarInput
        id='partner-email'
        label='Email address'
        icon={faEnvelope}
        value={email}
        placeholder='Email address'
        type='email'
        autoComplete='email'
        cb={(e) => setEmail(e.target.value)}
        disabled={checking}
      />

      <BarInput
        id='partner-password'
        label='Password'
        icon={faKey}
        value={password}
        placeholder='Enter password'
        type='password'
        autoComplete='current-password'
        cb={(e) => setPassword(e.target.value)}
        disabled={checking}
      />
      {renderButton()}
      {failure ? (
        <div className='login-error' role='alert'>
          <p>{failure}</p>
          <p>Contact Voltera for assistance</p>
        </div>
      ) : null}
    </form>
  );
}
